import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
const mediaItems = [{
  type: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/9yu9d6r1XZSRKzDAm8TNjF/ANTES Y DESPUÉS de labios con ácido hialuronico 💉 Los resultados sutiles que siempre destacamos.mp4',
  label: 'Armonización Labial'
}, {
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/59KN4WcV51XhudLJfePq78/¿Queres_mejorar_caracteristicas_de_tu_nariz_sin_pasar_por_una_cirugia_👃🏻La_rinomodelacion_con_(1).jpg',
  label: 'Rinomodelación'
}, {
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/r8GZ4DXxzy4ifFd9U8xvxe/MESOTERAPIA_FACIAL_🧴✨¿Cuales_son_sus_principales_beneficios_-_Mejora_la_textura_de_la_piel_-_Re.jpg',
  label: 'Mesoterapia Facial'
}, {
  type: 'image',
  src: 'https://cdn.magicpatterns.com/uploads/1q8UJYP9fhwmFWi5gm5dTj/¿Queres_mejorar_caracteristicas_de_tu_nariz_sin_pasar_por_una_cirugia_👃🏻La_rinomodelacion_con_.jpg',
  label: 'Rinomodelación'
}, {
  type: 'video',
  src: 'https://cdn.magicpatterns.com/uploads/gWy13pet1YsmJQnZcFpXkR/Tu momento de relax y de autocuidado 🤍Logra una renovación de tu piel ✨, eliminando impurezas e.mp4',
  label: 'Skin Quality'
}];
export function Gallery() {
  return <section className="py-24 bg-white border-t border-rosegold/10" data-id="element-59">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-60">
        <div className="text-center mb-16" data-id="element-61">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-serif text-3xl md:text-4xl text-charcoal mb-4" data-id="element-62">
            Experiencia Mantra
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-charcoal/70 text-lg max-w-2xl mx-auto" data-id="element-63">
            Resultados reales y momentos de cuidado. Un vistazo a la naturalidad
            y excelencia de nuestros procedimientos.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6" data-id="element-64">
          {mediaItems.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="relative group rounded-2xl overflow-hidden aspect-[4/5] shadow-soft bg-ivory" data-id="element-65">
              {item.type === 'video' ? <video src={item.src} autoPlay muted loop playsInline className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-66" /> : <img src={item.src} alt={item.label} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-67" />}

              {/* Overlay on Hover */}
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/80 via-charcoal/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-6" data-id="element-68">
                <span className="text-white font-serif text-xl tracking-wide" data-id="element-69">
                  {item.label}
                </span>
              </div>
            </motion.div>)}

          {/* CTA Card to complete the 6-grid */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.5
        }} className="relative rounded-2xl overflow-hidden aspect-[4/5] bg-rosegold/10 border border-rosegold/20 flex flex-col items-center justify-center text-center p-8 shadow-soft" data-id="element-70">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center text-rosegold mb-6 shadow-sm" data-id="element-71">
              <Sparkles size={28} strokeWidth={1.5} data-id="element-72" />
            </div>
            <h3 className="font-serif text-2xl text-charcoal mb-4" data-id="element-73">
              Tu turno de brillar
            </h3>
            <p className="text-charcoal/70 mb-8 text-sm md:text-base" data-id="element-74">
              Da el primer paso hacia tu mejor versión con una consulta
              personalizada.
            </p>
            <a href="#reservar" className="bg-rosegold text-white px-6 py-3 rounded-full text-sm font-medium hover:bg-rosegold-600 transition-colors shadow-sm" data-id="element-75">
              Agendar cita
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}